export default {
  title: {
    entrance: 'מנווטים אותך<br /><b>להחלטות פיננסיות נכונות</b>',
    main: 'אנחנו בפולאריס עוסקים במתן שירותי ניהול הון אישי <br />ותכנון פרישה ללקוחות אמידים שרוצים <b>למצות את המיטב</b> ממקורותיהם הפיננסיים, <b>לשמר את עושרם <br>ולהעבירו לדורות הבאים.</b>',
  },
};
